import { useState, useEffect } from 'react';

import { useSearchParams } from 'react-router-dom';
/**
 *
 * @param {*} key
 * @param {*} initialValue
 * @param {*} type string | filter | pagination
 * @returns
 */

// TODO:Improve the url structure with types
function useURLState(key, initialValue, type) {
  const [searchParams, setSearchParams] = useSearchParams();

  // Get the initial state from the URL if it exists, or use the provided initialValue
  const getInitialValue = () => {
    const urlValue = searchParams.get(key);
    return urlValue ? decode(key, urlValue, initialValue) : initialValue;
  };

  const [state, setState] = useState(getInitialValue);

  // Update the URL whenever the state changes
  useEffect(() => {
    const serializedValue = code(key, state);

    if (serializedValue === code(key, initialValue)) {
      setSearchParams(searchParams.delete(key));
    } else {
      setSearchParams((params) => params.set(key, serializedValue));
    }

    // Replace the URL without triggering a page reload
    setSearchParams(searchParams);
  }, [state]);

  return [state, setState];
}

export default useURLState;

const code = (key, state) => JSON.stringify(state);

const decode = (key, state, initialValue) => {
  if (state !== 'undefined') {
    try {
      const value = JSON.parse(state);
      return value;
    } catch (error) {
      return initialValue;
    }
  }
  return initialValue;
};
